import AccountInfo from './accountInfo';

export default AccountInfo;
